module.exports = __webpack_public_path__ + "static/media/HX.e0b5b845.jpg";